import { RankedTester, rankWith, uiTypeIs } from "@jsonforms/core";

export const verticalLayoutTester: RankedTester = rankWith(3, uiTypeIs("VerticalLayout"));
